import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { MarkdownModule } from 'ngx-markdown';

@Component({
  selector: 'app-legal-page',
  imports: [MarkdownModule],
  templateUrl: './legal-page.component.html',
  styleUrl: './legal-page.component.scss',
})
export class LegalPageComponent implements OnInit {
  protected pageTitle = '';
  protected markdownContent: string | null = null;
  protected isLoading = true;
  protected hasError = false;

  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: object,
    private readonly route: ActivatedRoute,
    private readonly http: HttpClient
  ) {}

  public ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
    const data = this.route.snapshot.data;
    this.pageTitle = data['pageTitle'] ?? '';
    const docId: string = data['docId'] ?? '';
    this.loadMarkdown(docId);
  }

  private loadMarkdown(docId: string): void {
    this.http.get(`assets/legal/${docId}.md`, { responseType: 'text' }).subscribe({
      next: content => {
        this.markdownContent = content;
        this.isLoading = false;
      },
      error: () => {
        this.hasError = true;
        this.isLoading = false;
      },
    });
  }
}
